import React, { useState, useEffect } from "react";
export const HeroSection = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
  <section
    className="animate-fade-in"
    style={{
      textAlign: "center",
      padding: "20px",
      backgroundColor: "white",
      color: "white",
      flex: "0 1 30vh",
      flexWrap: "wrap",
      alignItems: "center",
      margin: "0.5rem auto",
      transform: isMobile ? "translateX(0%)" : "translateX(0%)",
      maxWidth: isMobile ? "100%" : "70%",
    }}
  >
    <div
      className="hero-card"
      style={{
        display: "flex",
        justifyContent: "center",
        alignContent: "center",
        padding: "2rem",
        backgroundColor: "white",
        borderRadius: "10px",
        flex: "0 1 30vh",
        flexWrap: "wrap",
        alignItems: "stretch",
        width: "96%",
        maxWidth: "1400px",
        margin: "1.5rem auto",
        boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.4)",
      }}
    >
      <div
        className="hero-copy"
        style={{
          justifyContent: "flex-start",
          alignItems: "center",
          backgroundColor: "rgb(90, 90, 90, 0.85)",
          padding: "3.5rem 2.5rem",
          minWidth: 0,
          flex: "0 0 20%",
          maxWidth: "100%",
          minHeight: "580px",
          display: "flex",
          flexDirection: "column",
          borderRadius: "5px 0 0 5px",
        }}
      >
        <p className="hero-copy__welcome">Welcome</p>
        <div className="hero-copy__middle">
          <h1
            style={{
              fontSize: "2.5rem",
              fontWeight: "normal",
              fontFamily: "Playfair Display, Georgia, serif",
              letterSpacing: "1px",
              margin: 0,
            }}
          >
            Health Care Made Easy.
          </h1>
          <p
            style={{
              fontSize: "1em",
              fontWeight: "bold",
              fontFamily: '"Playfair Display", Georgia, serif',
              letterSpacing: "3px",
              margin: "1.25rem 0 0",
            }}
          >
            Expertise You Can Rely On.
          </p>
        </div>
        <a className="hero-consult" href="/contact-us">
          Free Consultation
        </a>
      </div>
      <img
        src="/ito-doctor.webp"
        alt="Stethoscope and medical clipboard on a desk"
        width={1000}
        height={1000}
        className="hero-photo"
        style={{
          minWidth: 0,
          flex: "0 0 58%",
          width: "58%",
          maxWidth: "58%",
          height: "580px",
          objectFit: "cover",
          borderRadius: "0 5px 5px 0",
        }}
      />
    </div>
  </section>
)};
